import { gsap } from '../global/gsap';

const initHomeHero = (element) => {
    const cloudWrap = element.querySelector('.js-cloud-wrap');
    const cloudGroups = element.querySelectorAll('.js-cloud-group');
    const clouds = element.querySelectorAll('.js-cloud');
    const blobWraps = element.querySelectorAll('.js-blob-wrap');
    const blobs = element.querySelectorAll('.js-blob');
    const heroUpper = element.querySelector('.js-hero-upper');

    gsap.to(cloudGroups, {
        x: (e, target) => `-${window.innerWidth + target.offsetWidth}`,
        duration: gsap.utils.random(150, 175),
        ease: 'none',
        stagger: {
            repeat: -1,
            each: gsap.utils.random(75, 150)
        }
    }).progress(0.2);

    gsap.to(clouds, {
        y: gsap.utils.random(-100, 100),
        duration: gsap.utils.random(10, 30),
        ease: 'power3.inOut',
        stagger: {
            repeat: -1,
            each: gsap.utils.random(1, 2),
            yoyo: true
        }
    });

    gsap.to(blobs, {
        y: gsap.utils.random(-50, -25),
        duration: gsap.utils.random(5, 10),
        ease: 'power3.inOut',
        stagger: {
            repeat: -1,
            each: gsap.utils.random(1, 5),
            yoyo: true
        }
    });

    const scrollTl = gsap.timeline({
        overwrite: true,
        scrollTrigger: {
            trigger: heroUpper,
            start: 'bottom bottom',
            end: 'bottom top',
            scrub: 0.5,
            invalidateOnRefresh: true
        },
    });

    scrollTl.addLabel('start');

    scrollTl.to(cloudWrap, {
        y: '-10%',
        duration: 3
    }, 'start');

    scrollTl.to(blobWraps, {
        y: '20%',
        duration: 3,
        stagger: {
            each: gsap.utils.random(-0.1, -1.5),
        }
    }, 'start');
};

export { initHomeHero as default };
